import { StorageKeys } from "../types/enums/Storage.enum";

export const NOMBRE_INSTITUCION = 'Poder Judicial';
export const NOMBRE_CALENDARIO = 'Agenda - '+ NOMBRE_INSTITUCION;


/**
 * Utilidades para localStorage
 */
export const storage = {
  /** */
  get: (key: StorageKeys) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  },
  set: (key: StorageKeys, value: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error guardando en localStorage:', error);
    }
  },
  remove: (key: StorageKeys) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removiendo datos desde localStorage:', error);
    }
  },
  clear: () => {
    try {
      /* Preservar el perfil seleccionado durante validaciones de token */
      const perfilActual = storage.get(StorageKeys.PERFIL);
      
      (Object.values(StorageKeys) as string[])
        .filter(value => typeof value === 'string')
        .forEach(key => {
          localStorage.removeItem(key);
        });
      
      /* Restaurar el perfil después de la limpieza */
      if (perfilActual) {
        storage.set(StorageKeys.PERFIL, perfilActual);
      }
    } catch (error) {
      console.error('Error limpiando localStorage:', error);
    }
  },
  /**
   * Limpiar TODO el localStorage sin excepciones
   * Usar solo en logout explícito del usuario
   */
  clearAll: () => {
    try {
      (Object.values(StorageKeys) as string[])
        .filter(value => typeof value === 'string')
        .forEach(key => {
          localStorage.removeItem(key);
        });
    } catch (error) {
      console.error('Error limpiando localStorage:', error);
    }
  }
};
/**
 * Opciones de paginación comunes
 */
export const LISTA_OPCIONES_PAGINACION = [5, 10, 25, 50, 100];  